<template>
  <div id="addSubscription">
    <v-overlay :value="loading" z-index="6">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
    <v-row no-gutters justify="start">
      <v-col cols="8">
        <v-card class="pa-3">
          <v-card-title>
            <h4>{{$t($route.meta.breadcrumb[2].text)}}</h4>
          </v-card-title>
           <v-card-subtitle>
            <p>{{$t('subscriptions.formMessage')}}</p>
          </v-card-subtitle>
          <v-card-text>
            <v-progress-linear v-if="isEdit && loadItem" color="primary" indeterminate/>
            <p v-if="isEdit && loadItem" class="text-center">{{$t('general.loading')}}</p>
            <v-form
              lazy-validation
              ref="form"
              v-model="valid"
              v-if="!loadItem || !isEdit"
            >
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    :disabled="isEdit"
                    outlined
                    dense
                    color="primary"
                    :items="companies"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    v-model="editedItem.company_id"
                    hide-details="auto"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.company')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    dense
                    color="primary"
                    :items="plans"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    v-model="editedItem.plan_id"
                    hide-details="auto"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.plan')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-checkbox 
                    class="mt-0 mb-2 d-inline-block"
                    hide-details
                    :label="$t('general.expirationDate') + '?'"
                    v-model="hadExpiration"
                  />
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        outlined
                        v-if="hadExpiration"
                        dense
                        :disabled="!hadExpiration"
                        v-model="editedItem.expiration_date"
                        prepend-inner-icon="event"
                        readonly
                        v-on="on"
                        :rules="rules.requiered"
                      ></v-text-field>
                      <v-text-field
                        outlined
                        dense
                        v-else
                        :disabled="!hadExpiration"
                        v-model="editedItem.expiration_date"
                        prepend-inner-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker :min="today" color="primary" v-model="editedItem.expiration_date" @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" outlined @click="redirect">{{$t('general.cancel')}}</v-btn>
            <v-btn color="primary" depressed @click="add">{{$t('general.accept')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'addSubscription',
  data () {
    return {
      loading: false,
      loadItem: true,
      menu: false,
      plans: [],
      today: new Date().toISOString().substr(0, 10),
      valid: true,
      hadExpiration: false,
      editedItem: {
        company_id: '',
        expiration_date: '',
        plan_id: ''
      },
      options: {
        itemsPerPage: 0,
        page: 0,
        totalItems: 0
      },
      companies: []
    }
  },
  watch: {
    hadExpiration () {
      if (this.hadExpiration === true) {
        if (this.editedItem.expiration_date === '') {
          this.editedItem.expiration_date = new Date().toISOString().substr(0, 10)
        }
      } else {
        this.editedItem.expiration_date = ''
      }
    },
    'editedItem.expiration_date' () {
      if (this.editedItem.expiration_date.length > 0) {
        this.hadExpiration = true
      } else {
        this.hadExpiration = false
      }
    }
  },
  created () {
    this.$store.dispatch('company/get', {event: {item: {perPage: -1, page: 1}, context: this}})
    this.$store.dispatch('subscriptions/getPlans', {event: {context: this}})
    if (this.isEdit) {
      this.$store.dispatch('subscriptions/getById', {event: {item:{id: this.$route.params.id}, context: this}})
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    },
    isEdit () {
      if (this.$route.params.id) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    add () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.isEdit) {
          this.$store.dispatch('subscriptions/put', {event: {item: this.editedItem, context: this}})
        } else {
          this.$store.dispatch('subscriptions/post', {event: {item: this.editedItem, context: this}})
        }
      }
    },
    redirect () {
      this.$router.push('/subscriptions')
    }
  }
}
</script>